// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b8f5f70","455":"f613babd","977":"2b897241"}[chunkId] + ".chunk.js";
};